export default "__VITE_ASSET__LQdmaeAO__"